import React, {useContext, useRef} from 'react';
import {CorporationContext} from "../context/corporation-context.jsx";
import Tabs from "./tabs.jsx";
import corporationService from "../../../../services/web/corporation-service.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import {Template} from "../../../../components/template/template.jsx";
import {Card} from "../../../../components/card/card.jsx";
import Button from "../../../../components/button/button.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {toast} from "react-toastify";
import {useInactiveTabAutofillProtection} from "../../../../hooks/use-required-tab-errors.js";

const CorporationInit = () => {
    const {
        setIsLoading, state, changes, isLoading, tabs, tabSelected, setTabSelected, setChangesContext
    } = useContext(CorporationContext);
    const tabsRef = useRef(null);

    useInactiveTabAutofillProtection(tabsRef, tabSelected);

    const save = () => {
        const formData = prepareData();

        setIsLoading(true);

        corporationService.edit(formData)
            .then(() => {
                toast.success("Salvo com sucesso")
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? message;
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })
            .finally(() => {
                setIsLoading(false)
            });
    }

    const prepareData = () => {
        const formData = new FormData();

        const templates = handleTemplates(state.templates)

        templates.map((t) => {
            if (t.file) {
                formData.append("templateImages[]", t.file);
            }
        })

        const form = {
            address: state.address,
            number: state.number,
            neighborhood: state.neighborhood,
            phone: state.phone,
            institutional_email: state.institutional_email,
            latitude: state.latitude,
            longitude: state.longitude,
            contacts: JSON.stringify([{email: state.contacts_email, phone: state.contacts_phone, itemId: 0}]),
            sos_display_name: state.sos_display_name,
            alternative_phone: state.alternative_phone,
            sos_address: state.sos_address,
            sos_number: state.sos_number,
            sos_phone: state.sos_phone,
            sos_email: state.sos_email,
            maria_da_penha_label: state.maria_da_penha_label,
            templates: JSON.stringify(templates),
            boName: state.boName,
            fullBoName: state.fullBoName,
            dispatch_help_terms: state.dispatch_help_terms,
            ecap_name: state.ecap_name,
            ecap_acronym: state.ecap_acronym,
            maria_da_penha_image: state.maria_da_penha_image,
            sos_image_id: state.sos_image_id,
            maps_api_key: state.maps_api_key,
        };

        if (state.logoEntity) formData.append('logo-entity', state.logoEntity);
        if (state.logoSos) {
            formData.append('logo-sos', state.logoSos);
        }

        if (state.logoMariaDaPenha) {
            formData.append('logo-maria-penha', state.logoMariaDaPenha);
        }

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        formData.append('_method', 'PUT');

        return formData;
    }

    const handleTemplates = (templates) => {
        return templates.map(item => {
            if (typeof item.id === 'string') {
                const {id, ...rest} = item;
                return rest;
            }
            const {imagePath, ...rest} = item;

            return rest;
        });
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Corporação
                </Template.Title>
            </Template.Header>

            <Template.Body>
                <div className="flex gap-2">
                    <div className="w-[256px] flex flex-col h-[calc(100vh-69px)]">
                        <Tabs tabSelected={tabSelected} setTabSelected={setTabSelected}/>
                    </div>
                    <div className="relative w-[calc(100%_-_256px)]">
                        <div ref={tabsRef} className={"user-report h-[calc(100vh_-_131px)]"}>
                            {tabs.map(({key, component}) => (
                                <div
                                    key={key}
                                    data-required-tab={key}
                                    hidden={tabSelected !== key}
                                    aria-hidden={tabSelected !== key}
                                >
                                    {component}
                                </div>
                            ))}
                        </div>
                        <Card className={"mt-2"}>
                            <Card.Body>
                                <div className={"flex justify-end gap-2"}>
                                    <Button onClick={save} disabled={changes.length === 0} actionFeedbackType='save' onActionFeedbackSuccess={() => setChangesContext([])}>

                                        Salvar
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Template.Body>
        </Template>
    );
}

export default CorporationInit;